/**
 * Created by yangxuanbin on 07/02/2018
 **/
const getItem=(key)=>{
    let value;
    try {
        value = localStorage.getItem(key)
    } catch (ex) {
        console.error('localStorage.getItem报错, ', ex.message)
    }

    return value==""?{}:JSON.parse(value);
};

const setItem=(key, value)=>{
    try {
        localStorage.setItem(key,JSON.stringify(value));
        return true;
    } catch (ex) {
        console.error('localStorage.setItem报错, ', ex.message);
        return false;
    }
};

const removeItem = (key)=>{
    localStorage.removeItem(key);
};

const storage = {
    getItem,
    setItem,
    removeItem
};

export default storage;


// WEBPACK FOOTER //
// ./src/utils/localStore.js